import { render, staticRenderFns } from "./MamFollower.vue?vue&type=template&id=1948f054&scoped=true"
import script from "./MamFollower.vue?vue&type=script&lang=js"
export * from "./MamFollower.vue?vue&type=script&lang=js"
import style0 from "./MamFollower.vue?vue&type=style&index=0&id=1948f054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948f054",
  null
  
)

export default component.exports